export const STORE_SETTINGS_API_URL = 'ui/organization/store_settings';

export const storeSettingsQueryKeys = {
  all: [STORE_SETTINGS_API_URL],
};
